export const FEATURE_UPGRADE_DIALOG_INSTANCES = {
  AI_IN_CPE: 'ai-in-cpe',
  AUTOMATION_3PL: 'automation-3pl',
  AUTOMATION_LEGACY: 'automation-legacy',
  CONTACTS: 'contacts',
  DYNAMIC_CONTENT_BLOCK: 'dynamic-content-block',
  EMAIL: 'email',
  EMAIL_EDITOR: 'email-editor',
  EMAIL_REPORTS_CLICK_THROUGH: 'email-reports-click-through',
  EMAIL_REPORTS_NEW: 'email-reports-new',
  GLOBAL_1_CLICK_UPGRADE: 'global-1-click-upgrade',
  LIBRARY_PAGE: 'library-page',
  MY_ACCOUNT: 'my-account',
  PLANS_AND_PRICING_BUTTON_IN_NAV: 'plans-and-pricing-button-in-nav',
  REPORTING: 'reporting',
  SEGMENTATION: 'segmentation',
  SEO: 'seo',
  SOCIAL_AND_SOCIAL_ADS: 'social-and-social-ads',
  SURVEYS_LEGACY: 'surveys-legacy',
  UPGRADE_BUTTON_IN_NAV: 'upgrade-button-in-nav',
};
